/* eslint-disable */
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { t } from "i18next";
import React from "react";
import { Link, useParams } from "react-router-dom";

const EventQuotationSellHeader = ({
  isEventModerator,
  changeStatusHandler,
  reloadQuotations,
}) => {
  const breadCrumbText = [
    { title: t("Event"), link: "/admin/events/list" },
    { title: t("Quotations") },
  ];

  const params = useParams();

  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb
            breadCrumbText={breadCrumbText}
            top={false}
            displayName={t("Sell")}
          />
        </div>

        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* ------ refresh icon start ------ */}
          <Link
            onClick={reloadQuotations}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* ------ refresh icon end ------ */}

          {/* --- view redirect section start --- */}
          {isEventModerator ? (
            <div className="dropdown flex-fill flex-grow-sm-0">
              <button
                className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="fw-semibold small">{t("List View")}</span>
                <span className="material-symbols-outlined icon-lg ms-1">
                  expand_more
                </span>
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to={`/admin/events/quotations/sell/${params.id}`}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      list
                    </span>
                    <span className="d-block">{t("List View")}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    to={`/admin/events/quotations/sell/kanbankit/${params.id}`}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      view_kanban
                    </span>
                    <span className="d-block">{t("Kanban View")}</span>
                  </Link>
                </li>
              </ul>
            </div>
          ) : null}
          {/* --- view redirect section end --- */}

          {/* --- action section start --- */}
          {isEventModerator ? (
            <div className="dropdown flex-fill flex-grow-sm-0">
              <button
                className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="fw-semibold small">{t("Action")}</span>
                <span className="material-symbols-outlined icon-lg ms-1">
                  expand_more
                </span>
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
                {/* --- manage labels start --- */}
                <li>
                  <Link
                    to="#"
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    data-bs-toggle="modal"
                    data-bs-target="#addLabelModal"
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      label
                    </span>
                    <span className="d-block">{t("Manage Label")}</span>
                  </Link>
                </li>
                {/* --- manage labels end --- */}

                {/* --- delete start --- */}
                <li>
                  <Link
                    to="#"
                    className="dropdown-item d-flex align-items-center gap-2 py-2 text-danger"
                    onClick={changeStatusHandler}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      delete
                    </span>
                    <span className="d-block">{t("Delete")}</span>
                  </Link>
                </li>
                {/* --- delete end --- */}
              </ul>
            </div>
          ) : null}
          {/* --- action section end --- */}

          <Link
            to="#"
            className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasQuotationSellFilter"
            aria-controls="offcanvasQuotationSellFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventQuotationSellHeader;
